import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AdminPanelWelcomeRequestDto } from "../../../api/apiServices/backOffice/controllers/adminPanel/adminPanel.requestsDto";
import { WelcomeModel } from "../../../viewModels/AdminPanel/WelcomeModel";

const initialState: { data?: WelcomeModel; loading: boolean; error: boolean; forbidden: boolean } = {
  loading: true,
  error: false,
  forbidden: false,
};
const slice = createSlice({
  name: "adminPanelWelcome",
  initialState,
  reducers: {
    load(state, _action: PayloadAction<AdminPanelWelcomeRequestDto>) {
      state.loading = true;
      state.error = false;
      state.forbidden = false;
      state.data = undefined;
    },
    loadSuccess(state, action: PayloadAction<WelcomeModel>) {
      state.data = action.payload;
      state.loading = false;
    },
    loadReject(state, action: PayloadAction<boolean>) {
      state.loading = false;
      state.error = true;
      state.forbidden = action.payload;
    },
    reset() {
      return initialState;
    },
  },
});
export default slice;
